/* eslint-env browser */
const Sentry = require('@sentry/browser')

let initialized = false

const SENTRY_DSN = 'https://e9b6f5ad2a4d469ab66d5fa827bf197d@o410142.ingest.us.sentry.io/5339441'

function initSentry() {
  if (initialized) return
  const config = window.initialState && window.initialState.config

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: (config && config.sentryEnvironment) || 'production',
  })
  initialized = true
}

function captureException(err) {
  if (!initialized) {
    initSentry()
  }
  if (initialized) {
    Sentry.captureException(err instanceof Error ? err : new Error(String(err)))
  }
}

module.exports = { initSentry, captureException }
